import { render, staticRenderFns } from "./HospitalizationPopup.vue?vue&type=template&id=2de3c45a&scoped=true&"
import script from "./HospitalizationPopup.vue?vue&type=script&lang=js&"
export * from "./HospitalizationPopup.vue?vue&type=script&lang=js&"
import style0 from "./HospitalizationPopup.vue?vue&type=style&index=0&id=2de3c45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de3c45a",
  null
  
)

export default component.exports